if (!customElements.get('tab-togglebar')) {
  class TabTogglebar extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.addEventListener('change', e => {
        const value = e.target.value;
        const currScroll = window.scrollY;
        [...this.querySelectorAll('[data-tab-content]')].forEach((content) => {
          if (content.dataset.tabContent === value) {
            content.style.transform = null;
            content.style.height = `${content.scrollHeight}px`;
            return;
          }
          
          content.style.transform = 'scale(0)';
          content.style.height = 0;
        });
        window.scrollTo(0, currScroll);
      });
    }
  }
  
  customElements.define('tab-togglebar', TabTogglebar);
}
